

import React, { memo } from 'react';
import _get from 'lodash.get';
import { Button, LabelWrapper, Text } from '../../../../../ui-kit';
import Caption from '../Caption';
import './_burnin-captions.scss';








export const CAPTION_PLACEHOLDER = 'Burn-in captions are stored permanently on the video file and play as part of your video – best compatibility, limited to one language.';

function onChangeBurnIn({ onChange, value }) {
  return () => {
    onChange({ value });
  };
}

function renderPlaceHolder(placeholder) {
  return <Text caption noMargin>{placeholder || CAPTION_PLACEHOLDER}</Text>;
}

function BurnInCaptions({
  addons,
  onChangeAddon,
  disabled,
  placeholder
}) {
  const onChange = onChangeAddon('BURN_IN_CAPTIONS');
  const value = _get(addons, 'BURN_IN_CAPTIONS');
  const hasBurnin = Boolean(value) || value === '';
  const selectedCaptions = [value];

  return (
    <LabelWrapper
      divContainer
      label="Burn-In Captions"
      extraLabelContent={!disabled && value === null &&
      <Button
        type="TERTIARY"
        prefix="addfat"
        onClick={!hasBurnin ? onChangeBurnIn({ onChange, value: '' }) : void 0}
        disabled={hasBurnin} />}>



      <div className="burnin-captions">
        {
        hasBurnin ?

        <Caption
          defaultLanguage={addons.BURN_IN_CAPTIONS || { value: null }}
          onDelete={() => onChange(null)}
          onChange={onChange}
          selectedCaptions={selectedCaptions}
          disabled={disabled}
          type="BURN_IN_CAPTIONS" /> :


        renderPlaceHolder(placeholder)}

      </div>
    </LabelWrapper>);

}

export default memo(BurnInCaptions);